/**
 * @fileoverview NotificationForm page entry — composes hooks and layout.
 * @module pages/NotificationForm
 */
import useNotificationForm from "./notificationForm/useNotificationForm.js";
import NotificationFormView from "./notificationForm/NotificationFormView.jsx";

/** Composes NotificationForm state/handlers and presentational layout. */
const NotificationForm = () => {
  const viewModel = useNotificationForm();
  return <NotificationFormView {...viewModel} />;
};

export default NotificationForm;
